const Dashboard = {

    // PAGE HEADER
    "dashboard": "Dashboard",

    // CARDS
    "customer_details": "Customer Details",
    "plan_details": "Plan Details",
    "plan_speed": "Plan Speed",
    "used_quota": "Used Quota",

    // FIELDS
    "name": "Name",
    "address": "Address",
    "mobile": "Mobile No",
    "plan_status": "Plan Status",
    "plan_name": "Plan Name",
    "remaining_days": "Remaining Days",
    "allocated_ip": "Allocated IP",
    "ott_service": "OTT Service",
    "voice_service": "Voice Service",
    "days": "DAYS",
    "unlimited": "Unlimited",
    "expires_on": "Expires on",
    "days_validity": "days plan validity",
    "no_plan_active": "No plan is active!",
    "loading": "Loading your account...",

}

export default Dashboard;
